import { render, staticRenderFns } from "./CompMainNavbarSubItemCard.vue?vue&type=template&id=65bd815a"
import script from "./CompMainNavbarSubItemCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompMainNavbarSubItemCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports